import Keycloak from 'keycloak-js'
import keycloakConfig from '../shared/keycloakConfig'

const keycloak = new Keycloak(keycloakConfig)

export default keycloak
